"use client";

import * as React from "react";
import { Quote, Star, ShieldCheck, Award, CircleCheck, ThumbsUp } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Client A.R. (Redacted)",
  quote: "RECOVERY SUCCESS: 14.2 BTC recovered from a legacy wallet after 7 years of inactivity. Absolute precision.",
  position: "VERIFIED CASE • Forensic Recovery",
  rating: 5
}, {
  author: "Investor M.S. (Redacted)",
  quote: "ASSET TRACING: Identified the flow of 85,000 USDT through mixer protocols to a centralized exchange.",
  position: "VERIFIED CASE • Scam Investigation",
  rating: 5
}, {
  author: "User L.K. (Redacted)",
  quote: "ACCESS RESTORED: Successfully bypassed hardware encryption failure on a corrupted cold storage device.",
  position: "VERIFIED CASE • Hardware Forensics",
  rating: 5
}];
const trustLogos = [{
  name: "Forensic Certified",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/promover_certification_logo.png"
}, {
  name: "Global Cyber Alliance",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/bbb_accredited_business_logo.png"
}, {
  name: "Blockchain Security",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/licensed_insured_badge_logo.png"
}, {
  name: "Financial Intelligence",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/chamber_of_commerce_member_logo.png"
}, {
  name: "Data Protection Act",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/safety_excellence_award_logo.png"
}];
export default function TrustPeaceOfMind() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="46058" id="success-stories" ref={sectionRef} className={`dark bg-background text-foreground py-20 overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        
        <div className="mb-20 relative">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 tracking-tighter uppercase">
              Success Stories
            </h2>
            <div className="h-1 w-20 bg-primary mx-auto rounded-sm" />
          </div>

          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full max-w-4xl mx-auto [perspective:1200px]">
            <CarouselContent className="[transform-style:preserve-3d]">
              {testimonials.map((testimonial, index) => <CarouselItem key={index} className="md:basis-full lg:basis-full" data-index={index}>
                  <div className="p-4 [transform-style:preserve-3d]">
                    <Card className="bg-card/30 border-primary/10 backdrop-blur-xl shadow-xl shadow-primary/5 rounded-sm transition-all duration-500 hover:[transform:rotateX(2deg)_rotateY(-2deg)_translateZ(20px)] hover:border-primary/30 hover:shadow-primary/10">
                      <CardContent className="flex flex-col items-center text-center p-8">
                        <div className="relative mb-6">
                           <Quote className="w-16 h-16 text-primary/20 rotate-180 animate-[spin_12s_linear_infinite] [transform:rotateX(45deg)]" />
                           <div className="absolute inset-0 bg-primary/5 blur-2xl rounded-full animate-pulse" />
                        </div>
                        
                        <blockquote className="text-2xl md:text-3xl font-medium leading-tight text-foreground mb-8 max-w-3xl">
                          &ldquo;{testimonial.quote}&rdquo;
                        </blockquote>

                        <div className="flex items-center gap-1 mb-4 text-primary">
                          {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current animate-[pulse_3s_ease-in-out_infinite] [transform-style:preserve-3d] transition-transform duration-700 hover:[transform:rotateY(360deg)]" style={{
                        animationDelay: `${i * 0.2}s`
                      }} />)}
                        </div>

                        <div className="flex flex-col items-center">
                          <cite className="not-italic font-semibold text-lg text-foreground mb-1">
                            {testimonial.author}
                          </cite>
                          <span className="text-primary text-xs font-mono uppercase tracking-widest">
                            {testimonial.position}
                          </span>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="bg-transparent border-primary/30 text-primary hover:bg-primary/10 hover:text-primary -left-12 rounded-sm" />
              <CarouselNext className="bg-transparent border-primary/30 text-primary hover:bg-primary/10 hover:text-primary -right-12 rounded-sm" />
            </div>
          </Carousel>
        </div>

        
        <div className="border-t border-primary/10 pt-16">
          <div className="text-center mb-10">
            <span className="text-xs font-mono text-muted-foreground uppercase tracking-[0.3em]">
              Verified Forensic Recovery Cases & Global Security Standards
            </span>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
            {trustLogos.map((logo, index) => <div key={index} className="group relative flex items-center justify-center p-4 transition-all duration-300" data-index={index}>
                
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10">
                   <ShieldCheck className="w-12 h-12 text-primary/40 animate-[spin_4s_linear_infinite] [transform:rotateX(45deg)]" />
                </div>

                <div className="relative">
                  {}
                  <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute top-0 left-0 w-full h-[1px] bg-primary/50 animate-[scan_2s_linear_infinite]" />
                    <div className="absolute inset-0 border border-primary/10 [background-image:radial-gradient(circle_at_center,transparent_0%,rgba(0,255,255,0.05)_100%)]" />
                  </div>
                  
                  <img src={logo.src} alt={logo.name} className="h-10 md:h-12 w-auto object-contain grayscale opacity-40 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 filter brightness-200 contrast-0 group-hover:brightness-100 group-hover:contrast-100" />
                </div>
              </div>)}
          </div>

          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 max-w-5xl mx-auto">
             <div className="flex flex-col items-center text-center space-y-3 group">
                <div className="p-4 rounded-sm bg-primary/5 border border-primary/20 transition-all duration-500 group-hover:border-primary/50 group-hover:shadow-[0_0_15px_rgba(0,255,255,0.2)] [transform-style:preserve-3d]">
                  <ShieldCheck className="w-6 h-6 text-primary animate-[pulse_4s_ease-in-out_infinite] group-hover:[transform:rotateY(180deg)] transition-transform duration-700" />
                </div>
                <h3 className="text-lg font-bold text-foreground uppercase tracking-tight">Forensic Precision</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">Advanced blockchain tracing and cryptographic analysis for asset recovery.</p>
             </div>
             <div className="flex flex-col items-center text-center space-y-3 group">
                <div className="p-4 rounded-sm bg-primary/5 border border-primary/20 transition-all duration-500 group-hover:border-primary/50 group-hover:shadow-[0_0_15px_rgba(0,255,255,0.2)] [transform-style:preserve-3d]">
                  <Award className="w-6 h-6 text-primary animate-[pulse_4s_ease-in-out_infinite] group-hover:[transform:rotateX(180deg)] transition-transform duration-700" style={{
                animationDelay: "1s"
              }} />
                </div>
                <h3 className="text-lg font-bold text-foreground uppercase tracking-tight">Expert Forensics</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">Certified specialists in digital asset security and private key restoration.</p>
             </div>
             <div className="flex flex-col items-center text-center space-y-3 group">
                <div className="p-4 rounded-sm bg-primary/5 border border-primary/20 transition-all duration-500 group-hover:border-primary/50 group-hover:shadow-[0_0_15px_rgba(0,255,255,0.2)] [transform-style:preserve-3d]">
                  <ThumbsUp className="w-6 h-6 text-primary animate-[pulse_4s_ease-in-out_infinite] group-hover:[transform:rotateZ(360deg)] transition-transform duration-700" style={{
                animationDelay: "2s"
              }} />
                </div>
                <h3 className="text-lg font-bold text-foreground uppercase tracking-tight">Secure Investigation</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">Strict confidentiality protocols and high-trust handling of every case.</p>
             </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scan {
          0% { top: 0; opacity: 0; }
          50% { opacity: 1; }
          100% { top: 100%; opacity: 0; }
        }
      `}</style>
    </section>;
}